var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaseMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 32 44",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 15.5294C32 24.1061 16 44 16 44C16 44 0 24.1061 0 15.5294C0 6.95275 7.51691 0 16 0C24.4831 0 32 6.95275 32 15.5294Z",
    fill: "#27AAE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseMarker);
export default __webpack_public_path__ + "static/media/base_marker.af5f996587d229217c48c1cd7e01738c.svg";
export { ForwardRef as ReactComponent };